import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { AlertService, ConstantService } from '@app/_services';
import { DatePipe } from '@angular/common';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { RateSeasonService } from '../rate-season.service';
import { RateSeason } from '../rate-season';
import { RateSeasonComponent } from '../rate-season/rate-season.component';
import { TapeChartService } from '../../tape-chart';
import { RateBucketsService } from '../../rate-bucket/rate-bucket.service';
import { Locations } from '@app/_helpers/constants';

@Component({
    selector: 'app-rateSeason-list',
    templateUrl: './rate-season-list.component.html',
    styleUrls: ['./rate-season-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class RateSeasonListComponent implements OnInit, OnChanges {
	categories: any;
	bucketNames: any[] = [];

	constructor(
		private rateSeasonService: RateSeasonService,
		private rateBucketsService: RateBucketsService,
		private tapeChartService: TapeChartService,
		private alertService: AlertService,
		private messageService: MessageService,
		private constantService: ConstantService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
		private datePipe: DatePipe
	) {
		this.statuses = rateSeasonService.statuses;
		this.categories = rateSeasonService.categories;
		this.locations = this.constantService.locations;
	}



	// data
	@Input() showFilter = true;
	@Input() showPagination = true;
	@Input() outlineNewButton = true;
	@Input() titleFontSize = false;
	@Input() rateBucketId: any;
	@Input() checkInDate: any;
	@Input() checkOutDate: any;
	@Input() reportSearchApi: any;
	@Input() updateSeasonList: boolean = false;
	@Input() isBulkEditing: boolean = false;
	@Output() doBulkUpdateCB = new EventEmitter<any>();
	rateSeasons: any;
	bulkSeasonsToBeUpdatedList: any = [];
	rateSeason: RateSeason;
	selectAllSeasons: boolean = false;

	// paging
	first = 0;
	rows = 25;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];
	multiFiltersMeta = {};

	// forms
	formLoading = false;

	statuses: any;

	locations: any;

	rateBucketTypes = [
		{ value: 1, name: 'Auto' },
		{ value: 2, name: 'Manual' }
	];

	frozenColumns: any[] = [
		{ field: 'RateBucketVO.name', header: 'Bucket'},
		{ field: 'locationId', header: 'Location'},
		{ field: 'name', header: 'Name'},
		{ field: 'startDate', header: 'Start'},
		{ field: 'endDate', header: 'End'}
	];

	columns: any[] = [
		{ field: 'listPriceAMT', header: 'List Price', width: 'auto' },
		{ field: 'listPriceAdjustAMT', header: 'List Price Adj Amt', width: 'auto' },
		{ field: 'listPriceAdjustPCT', header: 'List Price Adj PCT', width: 'auto' },
		{ field: 'category', header: 'Category', width: 'auto' },
		{ field: 'type', header: 'Type', width: 'auto' },
		{ field: 'floorRateManagerAMT', header: 'Floor Mngr', width: 'auto' },
		{ field: 'floorRateOwnerAMT', header: 'Floor Ownr', width: 'auto' },
		{ field: 'expectedOccupancyPCT', header: 'Expec Occup PCT', width: 'auto' },
		{ field: 'maxDiscountPCT', header: 'Max Disc PCT', width: 'auto' },
		{ field: 'discountLookForwardDays', header: 'Disc Forward Days', width: 'auto' },
		{ field: 'discountLookForwardHeadlineDays', header: 'Disc Forward Headline Days', width: 'auto' },
		{ field: 'discountLookForwardHeadlineMinNightsDays', header: 'Disc Forward Headline MinNights', width: 'auto' },
		{ field: 'minStayExpectedNTS', header: 'Min Stay Expec NTS', width: 'auto' },
		{ field: 'maxStayExpectedNTS', header: 'Max Stay Expec NTS', width: 'auto' },
		{ field: 'avgStayBySeasonNTS', header: 'Avg StayBySeason NTS', width: 'auto' },
		{ field: 'shortTermGapMultiplierPCT', header: 'ShortTerm Gap Multi PCT', width: 'auto' },
		{ field: 'shortTermGapPenaltyPCT', header: 'ShortTerm Gap Penalty PCT', width: 'auto' },
		{ field: 'shortTermGapMinNumNightsRevNTS', header: 'ShortTerm Gap Min NumNights Rev', width: 'auto' },
		{ field: 'longTermGapMultiplierPCT', header: 'LongTerm Gap Multi PCT', width: 'auto' },
		{ field: 'longTermGapPenaltyPCT', header: 'LongTerm Gap Penalty PCT', width: 'auto' },
		{ field: 'longTermGapEmptyMultiplierPCT', header: 'LongTerm Gap Empty Multi NTS', width: 'auto' },
		{ field: 'longTermGapEmptyPenaltyPCT', header: 'LongTerm Gap Empty Penalty PCT', width: 'auto' },
		{ field: 'connectingFrontOrBackMultiplierPCT', header: 'Connecting Front Or Back Multiplier PCT', width: 'auto' },
		{ field: 'connectingFrontAndBackMultiplierPCT', header: 'Connecting Front And Back Multiplier PCT', width: 'auto' },
		{ field: 'lengthOfStayDiscountFactorOffset', header: 'Length Of Stay Discount Factor Offset', width: 'auto' },
	];

	ngOnInit(): void {
		try {
			this.loadBucketNames();
			if(this.isBulkEditing)
			{
				this.rows = 200;
			}
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'startDate', order: 1 });
			let bucketIdList = [];
			this.multiFiltersMeta = [];
			//Filter selection for bulk edit component
			if(this.reportSearchApi && this.reportSearchApi.value?.startDate)
			{
				let date = this.datePipe.transform(this.reportSearchApi.value.startDate, 'yyyy-MM-dd');
				let startDate = {'startDate': { 'value': date, 'matchMode': 'in' } };
				Object.assign(this.multiFiltersMeta, startDate);
			}
			if(this.reportSearchApi && this.reportSearchApi.value?.endDate)
			{
				let date = this.datePipe.transform(this.reportSearchApi.value.endDate, 'yyyy-MM-dd');
				let endDate = {'endDate': { 'value': date, 'matchMode': 'in' } };
				Object.assign(this.multiFiltersMeta, endDate);
			}
			if(this.reportSearchApi && this.reportSearchApi.value?.seasonList)
			{
				let seasonList = {'category': { 'value': this.reportSearchApi.value.seasonList, 'matchMode': 'in' } };
				Object.assign(this.multiFiltersMeta, seasonList);
			}
			if(this.reportSearchApi && this.reportSearchApi.value?.locationRateBucketIdList)
			{
				this.reportSearchApi.value.locationRateBucketIdList.forEach(element => {
					let list = [];
					list.push(element);
					bucketIdList.push(list);
				});
			}
			if(this.reportSearchApi && this.reportSearchApi.value?.yielMaxRateBucketIdList)
			{
				this.reportSearchApi.value.yielMaxRateBucketIdList.forEach(element => {
					let list = [];
					list.push(element);
					bucketIdList.push(list);
				});
			}
			if(this.reportSearchApi && this.reportSearchApi.value?.yielMaxPropertyRateBucketIdList)
			{
				this.reportSearchApi.value.yielMaxPropertyRateBucketIdList.forEach(element => {
					let list = [];
					list.push(element);
					bucketIdList.push(list);
				});
			}
			let bucketIdFilter = {'rateBucketVO.rateBucketId': { 'value': bucketIdList, 'matchMode': 'in' } };
			Object.assign(this.multiFiltersMeta, bucketIdFilter);
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	ngAfterViewInit(): void {
		//For bulk edit component, show checkbox selection
		if(this.isBulkEditing)
		{
			//Add action column on 0 index
			this.frozenColumns.unshift({ field: 'action', header: 'Action'});
		}
	}

	ngOnChanges() {
		this.ngOnInit();
	}

	loadBucketNames() {
		if (this.bucketNames.length > 0) return;
		this.rateBucketsService.getAllRateBuckets().pipe(first()).subscribe(
			(res: any) => {
				const buckets = res.data?.rateBuckets || res.data?.rateBucketList || [];
				this.bucketNames = buckets
					.map((b: any) => ({ name: b.name, value: b.name }))
					.sort((a: any, b: any) => a.name.localeCompare(b.name));
			},
			(err: any) => {
				console.log('Failed to load bucket names: ' + JSON.stringify(err));
			}
		);
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.rateSeasonId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-rateSeason-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'startDate', order: 1 });
			}

			if(this.rateBucketId)
			{
				// show only activities that are assigned to this activityFeeId
				let rateBucketIdFilter = { 'rateBucketVO.rateBucketId': { 'value': this.rateBucketId, 'matchMode': 'in' } };
				Object.assign(event.filters, rateBucketIdFilter);
			}

			if(this.checkInDate && this.checkOutDate)
			{
				let checkInDate = { 'checkInDate': { 'value': this.checkInDate, 'matchMode': 'in' } };
				Object.assign(event.filters, checkInDate);
	
				let checkOutDate = { 'checkOutDate': { 'value': this.checkOutDate, 'matchMode': 'in' } };
				Object.assign(event.filters, checkOutDate);
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.rateSeasonService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.rateSeasons = res.data.rateSeasons;
						console.log(JSON.stringify(res.page));
						this.loading = false;
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.loading = false;
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.rateSeasons = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		if(!this.isBulkEditing)
		{
			this.onOpenFormEdit(event.data);
		}
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(rateSeason: RateSeason) {
		try {
			this.formLoading = true;
			this.rateSeasonService.update(rateSeason)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.rateSeasons.map((rateSeason, i) => {
							if (rateSeason.rateSeasonId === res.data.rateSeason.rateSeasonId) {
								this.rateSeasons[i] = res.data.rateSeason;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(rateSeason: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(rateSeason));

			this.formLoading = true;
			this.rateSeasonService.delete(rateSeason.rateSeasonId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.rateSeasons.splice(this.rateSeasons.indexOf(rateSeason), 1);
						this.recordTotal = this.rateSeasons.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'RateSeason ' + rateSeason.rateSeasonId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'RateSeason ' + rateSeason.rateSeasonId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		dialogConfig.maxWidth = "60vw";
			dialogConfig.width = "45vw";

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add RateSeason'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(RateSeasonComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addRateSeasonCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}

	generateRates()
  {
	try
	  {
	  this.loading = true;
	  this.tapeChartService.generateRates()
		.subscribe(
		res =>
		{
			this.loading = false; 
		},
		err =>
		{
			console.log('generateRates FAIL: ' + JSON.stringify(err));
			this.messageService.add({ severity: 'error', summary: 'Error', detail: err });
		},
		() => { this.loading = false; });

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Rates are being generated, please check back shortly for results.', life: 3000 });
		this.loading = false; 

	} catch (error)
	{
		this.loading = false;
		this.alertService.error(error);
	}
  }

	onSeasonSelection(rateSeason: any)
	{
		let isAllSeasonSelected = true;
		this.rateSeasons.forEach(rateSeason => {
			if(!rateSeason.isSelected)
			{
				isAllSeasonSelected = false;
				return;
			}
		});
		
		if(isAllSeasonSelected)
		{
			this.selectAllSeasons = true;
		}
		else
		{
			this.selectAllSeasons = false;
		}
	}

	onSeasonSelectionAll()
	{
		if(this.selectAllSeasons)
		{
			this.rateSeasons.forEach(rateSeason => {
				rateSeason.isSelected = true;
			});
		}
		else 
		{
			this.rateSeasons.forEach(rateSeason => {
				rateSeason.isSelected = false;
			});
		}
	}

	updateRatesInBulk()
	{
		this.bulkSeasonsToBeUpdatedList = [];
		this.rateSeasons.forEach(rateSeason => {
			if(rateSeason.isSelected)
			{
				this.bulkSeasonsToBeUpdatedList.push(rateSeason);
			}
		});
		this.doBulkUpdateCB.emit(this.bulkSeasonsToBeUpdatedList);
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(rateSeason: RateSeason) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		dialogConfig.maxWidth = "80vw";
			dialogConfig.width = "60vw";

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			rateSeason: rateSeason,
			title: 'Edit RateSeason'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(RateSeasonComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updateRateSeasonCB(data);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deleteRateSeasonCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addRateSeasonCB(rateSeason: RateSeason) {
		console.log('Adding RateSeason: ' + JSON.stringify(rateSeason));
		// if we don't have a rateSeasons array yet...
		if (!this.rateSeasons) {
			this.rateSeasons = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.rateSeasons.unshift(rateSeason);

		// no idea what this is but it is required to update the array
		this.rateSeasons = [...this.rateSeasons];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'RateSeason ' + rateSeason.rateSeasonId + ' Added', life: 3000 });
	}

	updateRateSeasonCB(rateSeason: RateSeason) {
		console.log('Updating RateSeason: ' + JSON.stringify(rateSeason));
		let itemIndex = this.rateSeasons.findIndex((item: any) => item.rateSeasonId === rateSeason.rateSeasonId);
		this.rateSeasons[itemIndex] = rateSeason;

		// no idea what this is but it is required to update the array
		this.rateSeasons = [...this.rateSeasons];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'RateSeason ' + rateSeason.rateSeasonId + ' Updated', life: 3000 });
	}

	deleteRateSeasonCB(rateSeason: RateSeason) {
		console.log('Removing RateSeason: ' + rateSeason);
		this.rateSeasons.splice(this.rateSeasons.indexOf(rateSeason), 1);
		this.recordTotal = this.rateSeasons.length;

		// no idea what this is but it is required to update the array
		this.rateSeasons = [...this.rateSeasons];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'RateSeason ' + rateSeason.rateSeasonId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.rateSeasons ? this.first === (this.rateSeasons.length - this.rows) : true; }
	isFirstPage(): boolean { return this.rateSeasons ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(rateSeason: any) {
		if (rateSeason?.status) {
			const status = this.statuses.find((e: any) => e.value == rateSeason.status);
			return status.name;
		}
		else {
			return '';
		}
	}

	reloadPage() {
		window.location.reload();
	}

	showPaginator()
	{
		return true;
	}

	categoryName(rateSeason: any) {
		if (rateSeason?.category) {
			const status = this.categories.find((e: any) => e.value == rateSeason.category);
			return status.name;
		}
		else {
			return '';
		}
	}

	rateBucketType(rateSeason: any) {
		if (rateSeason?.type) {
			const status = this.rateBucketTypes.find((e: any) => e.value == rateSeason.type);
			return status.name;
		}
		else {
			return '';
		}
	}

	get Locations() {
		return Locations;
	}
}
